 export enum PrimoboxNatureEnvoi {
Inconnu = 0,
Exercice = 1,
Selection = 2,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/PrimoboxNatureEnvoi.ts